// import { loadScript } from './loadScript'
import cpSite from './cpSite'
// import config from './config'

/**
 * Библиотека коррекции под мобильную версию
 */
const mobileCol = {
  state: {
    isActive: false
  },
  activate: function () {
    if (cpSite.config.DEVMODE) {
      console.log('active: mobileCol')
    }
    // Перенос копии drupal-меню в блок offcanvasMenuBody
    document.getElementById('offcanvasMenuBody').insertAdjacentElement('beforeend', document.querySelector('#suckerfishmenu > ul').cloneNode('true'))
    // Запись об активации скрипта
    this.state.isActive = true
  }
}
export default mobileCol
